import React from "react";

import { Link } from "react-router-dom";
import { translate } from "react-i18next";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.status = {
      show: false
    };
    this.toggleShow = this.toggleShow.bind(this);
  }

  toggleShow(event) {
    this.status.show = !this.status.show;
    this.setState(this.status);
  }

  render() {
    const { t } = this.props;

    return (
      <footer className="footer">
        <div className="container">
          <div className="row bottom-rule">
            <div className="col-sm-4 footer-section">
              <Link to="/">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo.svg"}
                  className="logo"
                  title="React test pages"
                  alt="React test pages"
                />
              </Link>
            </div>
            <div className="col-sm-5 footer-section">
              <ul className="list-inline">
                <li className="text-uppercase">mRecipes:</li>
                <li>
                  <a
                    href="http://www.aifb.kit.edu/web/Critical_Information_Infrastructures"
                    target="blank"
                  >
                    {t("team")}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.wiwi.kit.edu/Institute.php"
                    target="blank"
                  >
                    {t("articles")}
                  </a>
                </li>
                <li>
                  <a href="#/about">{t("whyRegister")}</a>
                </li>
              </ul>
              <ul className="list-inline">
                <li className="text-uppercase">{t("help")}:</li>
                <li>
                  <a href="#/sitemap">{t("functions")}</a>
                </li>
                <li>
                  <a href="#/privacy">{t("privacy")}</a>
                </li>
              </ul>
            </div>
            <div className="col-sm-3">
              <address>
                <strong>PS</strong>
                <br /> Office Street 12
                <br />
                76275 Ettlingen
                <br /> +49 7243 ...
                <br />
                <a href="mailto:peter.speck@web.de">{t("contactUs")}</a>
              </address>
            </div>
          </div>
          <div className="row bottom-rule">
            <div className="col-sm-12">
              <nav className="navbar navbar-default navbar-footer">
                <ul className="nav navbar-nav">
                  <li>
                    <a href="#">TODO_LINK1</a>
                  </li>
                  <li>
                    <a href="#">TODO_LINK2</a>
                  </li>
                  <li>
                    <a href="#/imprint">TODO_LINK3</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div className="row leg-room">
            <div className="col-md-12 text-center">
              <h3 className="text-uppercase">mRecipes</h3>
              <p className="monospaced">
                &copy;2019 reactTest{" "}
                <span className="text-uppercase">All Rights Reserved</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default translate()(Footer);
